<template>
  <img alt="Vue logo" src="./assets/logo.png">
  <Home msg="State of Order"/>
  <Registration />
</template>

<script>
import Home from './components/Home.vue'
import Registration from './components/Registration.vue';

export default {
  name: 'App',
  components: {
    Home,
    Registration
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
